import { Component, Vue } from 'vue-property-decorator';
import { sellerConfig } from '@/helpers/Config';
import { environment } from '@/helpers/Environment';
import { reserveTicketsPayload } from '@/helpers/Reserve';
import RadioGroup from '@/components/forms/RadioGroup.vue';
import { fetchDonationTG, fetchEventDetails } from '@/api/Events';
import { apiErrorMessageOrRethrow } from '@/errors/helpers';
import { replaceTickets } from '@/state/Reserve';
import store from '@/store/store';
@Component({
    name: 'CheckoutDonation',
    components: { RadioGroup },
})
export default class extends Vue {
    ticketGroupId = sellerConfig('checkout_donation_tg_id');
    // TODO Remove this once all tenants have migrated to checkout_donation_tg_id.
    eventId = environment.web.checkout_upsell_id;
    ticketGroup = null;
    errorMessage = null;
    submitting = false;
    created() {
        if (this.ticketGroupId) {
            fetchDonationTG(this.ticketGroupId)
                .then((group) => {
                this.ticketGroup = group;
            })
                .catch((error) => {
                // Do not let misconfigured checkout donation TGs surface to the UI.
                apiErrorMessageOrRethrow(error);
            });
        }
        else if (this.eventId) {
            // TODO Remove this code path once checkout_upsell_id is no longer used.
            fetchEventDetails(this.eventId).then((event) => {
                const groups = event.ticketGroups.filter((group) => group.handler === 'donation');
                if (groups.length > 0) {
                    this.ticketGroup = groups[0];
                }
            });
        }
    }
    get options() {
        if (this.ticketGroup) {
            return this.ticketGroup.types.map(({ id, name }) => ({
                value: id,
                label: name,
            }));
        }
        else {
            return [];
        }
    }
    onSelect(id, targetEl) {
        this.submitting = true;
        this.errorMessage = null;
        replaceTickets(this.cartChanges(id))
            .catch((error) => {
            this.errorMessage = apiErrorMessageOrRethrow(error);
        })
            .finally(() => {
            this.submitting = false;
            // refocus the input after the api call resolves, unless the user has focused something else.
            this.$nextTick(() => {
                if (document.activeElement === document.body) {
                    targetEl.focus();
                }
            });
        });
    }
    cartChanges(id) {
        return {
            remove: this.ticket ? [this.ticket.id] : [],
            add: id ? reserveTicketsPayload({ [id]: { quantity: 1 } }) : [],
        };
    }
    get ticket() {
        const tickets = store.getters['Cart/tickets'];
        if (this.ticketGroupId) {
            return tickets.find((ticket) => ticket.ticket_group_id === this.ticketGroupId);
        }
        else if (this.eventId) {
            return tickets.find((ticket) => ticket.event_template_id === this.eventId);
        }
        else {
            return null;
        }
    }
    get selectedDonationTTID() {
        return this.ticket?.ticket_type_id ?? null;
    }
}
